export type ContentBlock =
  | { type: 'h3'; text: string }
  | { type: 'p'; text: string };

export interface Category {
  slug: string;
  name: string;
  brief: string;
  count: number;
}

export interface Article {
  id: string;
  title: string;
  category: string;
  tags: string[];
  author: string;
  date: string;
  readTime: string;
  readCount: string;
  summary: string;
  image: string;
  imageAlt: string;
  hot?: boolean;
  pick?: boolean;
  featured?: boolean;
  content: ContentBlock[];
}

export const siteName = '每日新料';
export const siteSlogan = '比媒体更早，看到新机真容';

export const categories: Category[] = [
  { slug: 'specs', name: '参数曝光', brief: '第一时间汇总芯片、屏幕、影像等核心规格爆料', count: 128 },
  { slug: 'renders', name: '新机谍照', brief: '未发布产品图与渲染图集中营', count: 96 },
  { slug: 'price', name: '价格预测', brief: '提前锁定新机定价区间与配置梯度', count: 74 },
  { slug: 'inside', name: '厂商内幕', brief: '供应链、立项与发布节奏的内部消息', count: 63 },
  { slug: 'scene', name: '上手解读', brief: '爆料参数的解读与选购价值分析', count: 87 },
];

export const articles: Article[] = [
  {
    id: 'ling-zhi-xin-pian-zhongduan',
    title: '新一代中端旗舰芯片参数全曝光：大核频率冲到 3.1GHz，能效有望反超',
    category: 'specs',
    tags: ['芯片', '参数曝光', '能效'],
    author: '闪电爆料员',
    date: '2026.09.08',
    readTime: '4 分钟',
    readCount: '3.2w',
    summary: '供应链消息称这款面向中端市场的新主控采用台积电 3nm 制程，八核架构与缓存方案都已流出，理论跑分与功耗表现成为近期最受关注的参数焦点。',
    image: 'https://readdy.ai/api/search-image?query=closeup%20of%20a%20glossy%20dark%20smartphone%20system%20on%20chip%20silicon%20wafer%20render%20with%20circuit%20trace%20details%2C%20minimal%20studio%20lighting%2C%20warm%20editorial%20tech%20photography%20on%20soft%20cream%20background&width=900&height=600&seq=chip-soc-0001&orientation=landscape',
    imageAlt: '新一代中端芯片参数曝光渲染图',
    hot: true,
    content: [
      { type: 'p', text: '今日供应链曝光了一份面向中端市场的新一代主控核心参数清单。消息源称该芯片基于台积电更先进的制程打造，采用「1 超大核 + 3 大核 + 4 小核」的常见组合，但超大核的最高主频被标到了 3.1GHz，比前代有明显提升。' },
      { type: 'p', text: '值得注意的是，这份参数清单还透露了全新的缓存架构与基带方案，支持更高规格的 5G 载波聚合。有内部人士表示，这枚芯片在 Geekbench 类多核场景下的功耗曲线相比上代收窄，意味着长时间负载下的能效表现有望成为中端机的加分项。' },
      { type: 'h3', text: '大核频率提升意味着什么' },
      { type: 'p', text: '对普通用户而言，更高的峰值频率未必每天都会被用到，真正影响体验的是中高频段下的能效。爆料普遍认为，新主控更注重「长时间游戏不掉帧、日常使用更省电」这类真实场景，而非单纯刷高跑分。' },
      { type: 'p', text: '首批搭载该芯片的工程机预计在近期跑分平台密集现身，届时关于调度策略与温控的真实表现会更清晰。本站将持续跟踪后续参数曝光与量产进度。' },
    ],
  },
  {
    id: 'zhedie-ping-xinji-sheji',
    title: '下一代横向折叠屏新机谍照流出：更薄的转轴与近乎隐藏的折痕',
    category: 'renders',
    tags: ['折叠屏', '谍照', '转轴'],
    author: '镜头前的阿森',
    date: '2026.09.07',
    readTime: '3 分钟',
    readCount: '2.8w',
    summary: '一组未发布折叠屏新机的产品图在网络流传，机身明显更薄，折痕在展开后几乎不可见，疑似搭载新一代水滴铰链结构。',
    image: 'https://readdy.ai/api/search-image?query=minimal%20product%20render%20of%20a%20futuristic%20foldable%20smartphone%20opened%20flat%2C%20ultra%20thin%20design%2C%20seamless%20crease%20free%20display%2C%20studio%20photography%20on%20warm%20neutral%20cream%20background%2C%20soft%20even%20lighting%2C%20editorial%20tech%20style&width=900&height=600&seq=fold-phone-0001&orientation=landscape',
    imageAlt: '下一代折叠屏新机谍照渲染图',
    featured: true,
    content: [
      { type: 'p', text: '昨晚流出的这组未发布折叠屏新机产品图，来自某头部厂商的供应链环节。图片清晰展示了展开后的正面观感：屏幕占比极高，光线照在折痕位置时几乎看不到明显的凹陷，相比上一代有明显改进。' },
      { type: 'p', text: '机身侧面厚度在图中显得相当克制，消息源称这归功于新一代「双轴水滴」铰链结构与更紧凑的屏幕封装。重量控制在主流直板旗舰的区间，单手长时间使用负担更低。' },
      { type: 'h3', text: '转轴寿命仍是关注重点' },
      { type: 'p', text: '折叠屏的耐用性始终是用户最在意的问题。爆料指出，新铰链在弯折寿命测试与防尘表现上都设置了更高目标，部分样机已通过更严苛的反复开合验证。' },
      { type: 'p', text: '由于仍属未发布产品图，最终量产形态与调校仍有变数。我们会在更多真机与工程样张出现后第一时间更新报道。' },
    ],
  },
  {
    id: 'yingxiang-qijian-jiaqian',
    title: '影像旗舰价格预测：三款配置梯度清晰，顶配或守住两年前的水平线',
    category: 'price',
    tags: ['影像', '价格预测', '配置'],
    author: '价格侦探',
    date: '2026.09.06',
    readTime: '3 分钟',
    readCount: '1.9w',
    summary: '综合渠道与供应链口径，新一代影像旗舰预计提供三档配置，起售区间被多次暗示，顶配价格则被视为「加量不加价」的关键信号。',
    image: 'https://readdy.ai/api/search-image?query=elegant%20minimal%20render%20of%20a%20high%20end%20smartphone%20with%20large%20circular%20camera%20module%20on%20back%2C%20studio%20product%20shot%20on%20warm%20cream%20background%2C%20soft%20lighting%2C%20editorial%20photography%20style&width=900&height=600&seq=camera-phone-0001&orientation=landscape',
    imageAlt: '影像旗舰手机价格预测产品图',
    pick: true,
    content: [
      { type: 'p', text: '随着新一代影像旗舰发布临近，围绕定价的讨论开始升温。综合多家渠道预告与供应链备货口径，这款机型大概率延续「标准 / Pro / Ultra」的三档配置梯度，存储起步也统一上调。' },
      { type: 'p', text: '消息源多次暗示，标准版起售价格将维持在上一代同水位附近，通过影像与屏幕升级来「填配置」，而 Ultra 档顶配则被视为守住两年前水平线的关键。若属实，对持币观望的用户是相当友好的信号。' },
      { type: 'h3', text: '价格之外更值得关注的是提货节奏' },
      { type: 'p', text: '首发备货量不足往往导致溢价购买。爆料显示这次厂商在预购阶段或增加权益以平抑黄牛溢价。本站会结合更多渠道报价持续更新这份价格预测。' },
    ],
  },
  {
    id: 'gongchang-neimu-diaodu',
    title: '厂商内幕：新旗舰内部立项代号曝光，传闻「双影像联名」正在推进',
    category: 'inside',
    tags: ['内幕', '立项', '联名'],
    author: '圈子里的老K',
    date: '2026.09.05',
    readTime: '3 分钟',
    readCount: '2.1w',
    summary: '来自研发圈的消息称，某旗舰项目立项代号已经流出，内部对其影像方案颇为重视，传闻中的双品牌联名合作也被多次提及。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20a%20modern%20electronics%20research%20lab%20with%20prototype%20smartphone%20parts%20and%20blueprints%20on%20desk%2C%20warm%20dark%20ink%20tones%20with%20flame%20orange%20highlights%2C%20tech%20magazine%20style&width=900&height=600&seq=inside-factory-0001&orientation=landscape',
    imageAlt: '厂商内幕立项代号爆料配图',
    content: [
      { type: 'p', text: '今天来自研发圈子的一条内幕消息引起了不少讨论：某头部厂商的新一代旗舰项目立项代号已经流出，内部代号延续了往年「以城市命名的惯例」，据说带有强烈的「去库存、冲高端」指向。' },
      { type: 'p', text: '多位内部知情人士在非公开场合提及，该项目对影像能力的投入比例明显上升，传闻中的双影像品牌联名合作目前处于推进阶段，最终是否官宣仍看谈判结果。' },
      { type: 'h3', text: '内幕消息如何甄别' },
      { type: 'p', text: '需要提醒的是，立项代号与内部传闻并不等于最终产品。发布节奏、方案回退都很常见，本站会在信息源交叉验证后，用「可核验、有时间点」的方式呈现这类厂商内部消息。' },
    ],
  },
  {
    id: 'shangshou-zhenji-xiaolong',
    title: '参数猛但体验如何？上手解读这枚次旗舰芯片的真实价值',
    category: 'scene',
    tags: ['上手', '解读', '芯片'],
    author: '数码老白',
    date: '2026.09.04',
    readTime: '5 分钟',
    readCount: '2.6w',
    summary: '参数表好看不等于好用。从调度、续航与散热三个维度，拆解这枚曝光新芯片在上手阶段能带来什么真实价值。',
    image: 'https://readdy.ai/api/search-image?query=person%20hand%20holding%20a%20sleek%20modern%20smartphone%20in%20natural%20indoor%20light%2C%20shallow%20depth%20of%20field%2C%20warm%20editorial%20product%20photography%20on%20soft%20neutral%20background&width=900&height=600&seq=hands-on-0001&orientation=landscape',
    imageAlt: '次旗舰芯片上手解读配图',
    pick: true,
    content: [
      { type: 'p', text: '当一枚芯片的跑分与参数被反复曝光后，普通用户最关心的问题其实很朴素：日常到底顺不顺、续航够不够、发热压不压得住。这篇上手解读就从三个真实维度出发。' },
      { type: 'p', text: '从调度看，新芯片更倾向把中高频段交给大核与超大核，意味着刷信息流与轻中度游戏时的帧率更稳，而不是一味追求峰值。续航侧，能效曲线的改善让重度使用场景的温度更可控。' },
      { type: 'h3', text: '给想入手的人三个建议' },
      { type: 'p', text: '一是别被极端峰值跑分带节奏，二是优先关注散热堆料与系统调度版本，三是等首批真机评测出来再下结论。参数曝光只是起点，体验才是终点。' },
    ],
  },
  {
    id: 'pingmu-canmou-chengfen',
    title: '参数曝光：新一代旗舰屏幕亮度、色准与护眼规格浮出水面',
    category: 'specs',
    tags: ['屏幕', '参数', '护眼'],
    author: '闪电爆料员',
    date: '2026.09.03',
    readTime: '3 分钟',
    readCount: '1.5w',
    summary: '新旗舰面板参数被逐项列出：峰值亮度与高频 PWM 调光双双走高，色准与户外可读性成为升级重点。',
    image: 'https://readdy.ai/api/search-image?query=sleek%20smartphone%20showing%20vibrant%20display%20glowing%20with%20warm%20colorful%20gradient%2C%20front%20view%20studio%20product%20render%20on%20minimal%20warm%20background%2C%20editorial%20tech%20photography&width=900&height=600&seq=screen-panel-0001&orientation=landscape',
    imageAlt: '新一代旗舰屏幕参数曝光渲染图',
    content: [
      { type: 'p', text: '一块好屏幕的好坏，体现在亮度、色准、护眼和刷新体验的协同。最新曝光的旗舰面板参数显示，户外峰值亮度与低亮度下的高频调光频率都进一步提升。' },
      { type: 'p', text: '色准层面，新面板针对主流色彩空间的出厂校准覆盖更广，意味着看照片、修图时的色彩一致性更好。对长时间盯屏的用户，类自然光与节律护眼功能也是这次升级的重点。' },
      { type: 'h3', text: '亮度拉满真的好吗' },
      { type: 'p', text: '峰值亮度是面向强光场景的「余量」，日常体验更看自动亮度调校的顺滑度与功耗控制。参数曝光之外，真机的实际观感仍需首批上手验证。' },
    ],
  },
  {
    id: 'shangxian-beiwoliu-shepian',
    title: '疑似新机实拍谍照：后置模组布局大改，暗光样张风格独树一帜',
    category: 'renders',
    tags: ['谍照', '影像', '实拍'],
    author: '镜头前的阿森',
    date: '2026.09.02',
    readTime: '3 分钟',
    readCount: '2.3w',
    summary: '一组疑似未发布新机的实拍谍照流出，后置镜头模组布局与此前完全不同，夜景样张的色彩风格也引发网友讨论。',
    image: 'https://readdy.ai/api/search-image?query=professional%20night%20city%20street%20photography%20scene%20with%20bokeh%20lights%20captured%20by%20a%20smartphone%2C%20warm%20film%20like%20color%20tone%2C%20editorial%20style%2C%20modern%20minimal%20mood&width=900&height=600&seq=leak-shot-0001&orientation=landscape',
    imageAlt: '疑似新机实拍谍照夜景样张',
    content: [
      { type: 'p', text: '社交网络上流出的这组实拍谍照，让人第一次大致看清下一代旗舰的后置模组布局：镜头排列方式与现款完全不同，更强调「横置式」的专业观感。' },
      { type: 'p', text: '最受关注的是其中的夜景样张，暗部噪点控制与高光压制表现颇有大厂调校的痕迹，色彩风格比以往更「胶片感」，显然经过专门的影像调色。' },
      { type: 'h3', text: '谍照不等于最终样张' },
      { type: 'p', text: '需要说明的是，实拍谍照可能来自工程样机，最终量产版的算法与硬件未必一致。我们将其作为「方向性参考」，静待官方信息的进一步确认。' },
    ],
  },
  {
    id: 'yuce-xingjiaobi-zhongduan',
    title: '价格预测：中端主力机起步价浮出，两千元档又将迎来一场混战',
    category: 'price',
    tags: ['中端', '价格', '性价比'],
    author: '价格侦探',
    date: '2026.09.01',
    readTime: '3 分钟',
    readCount: '1.7w',
    summary: '多款中端新机的定价线索陆续出现，两千元档的配置与价格竞争进入白热化，消费者或将迎来近年最值得关注的一轮升级。',
    image: 'https://readdy.ai/api/search-image?query=clean%20minimal%20product%20render%20of%20an%20affordable%20mid%20range%20smartphone%20standing%20upright%2C%20warm%20cream%20studio%20background%2C%20soft%20shadow%2C%20editorial%20ecommerce%20photography&width=900&height=600&seq=mid-phone-0001&orientation=landscape',
    imageAlt: '中端主力机价格预测产品图',
    content: [
      { type: 'p', text: '两千元档一直是竞争最激烈、也是最考验厂商取舍的价位。近期多家厂商的中端新机定价线索陆续曝光，起步价被多次暗示将「守在一个很有诚意的位置」。' },
      { type: 'p', text: '从爆料口径看，这一代中端机普遍把「屏幕素质 + 快充 + 影像」作为突破口，而价格预测更多参考了上一代的清库存节奏与汇率成本。消息源认为，2026 下半年的两千元档会出现明显「加量」趋势。' },
      { type: 'h3', text: '买新还是等降价' },
      { type: 'p', text: '如果你对性能释放要求不高、更看重续航与价格，清库存阶段的上一代中端机依然有性价比；若希望多用两年、追新配置，则值得等这波新机集中上市后再做决定。' },
    ],
  },
  {
    id: 'chongdian-baofeng-tonggang',
    title: '厂商内幕：快充与电池「续命」方案背后，供应链悄然提速',
    category: 'inside',
    tags: ['快充', '电池', '供应链'],
    author: '圈子里的老K',
    date: '2026.08.30',
    readTime: '3 分钟',
    readCount: '1.4w',
    summary: '多则内部消息指向快充与电池技术的迭代节奏加快，电芯材料与协议互通成为供应链关注的新焦点。',
    image: 'https://readdy.ai/api/search-image?query=modern%20smartphone%20charging%20with%20wire%20on%20a%20minimal%20desk%2C%20warm%20moody%20lighting%2C%20abstract%20tech%20editorial%20render%20with%20energy%20glow%2C%20soft%20cream%20and%20orange%20tones&width=900&height=600&seq=charger-batt-0001&orientation=landscape',
    imageAlt: '快充与电池供应链内幕配图',
    content: [
      { type: 'p', text: '快充从来不是单一厂商的事，它牵动整个电芯、协议与充电配件供应链。近期多则内部消息显示，多家头部厂商正在同步提速新一代电池与快充方案的落地节奏。' },
      { type: 'p', text: '消息称，新的电芯材料在提升能量密度的同时，也把高倍率充电下的温度表现作为重要指标。与此同时，跨品牌快充协议的统一互通被频繁提及，有望缓解「出门没带对充电器就焦虑」的痛点。' },
      { type: 'h3', text: '内幕的价值在于提前规划' },
      { type: 'p', text: '对于准备换机的用户，这类厂商内部消息的意义在于帮助你判断「现在买会不会很快过时」。综合来看，快充与电池正处在一个升级窗口，耐心等待往往比抢先出手更划算。' },
    ],
  },
  {
    id: 'xinzhi-bianqian-gonglue',
    title: '选购攻略：如何看懂一波参数曝光，避免被「跑分焦虑」带节奏',
    category: 'scene',
    tags: ['选购', '攻略', '解读'],
    author: '数码老白',
    date: '2026.08.28',
    readTime: '6 分钟',
    readCount: '3.0w',
    summary: '面对铺天盖地的参数曝光与价格预测，普通消费者该如何理性看待？一份接地气的选购心法送上。',
    image: 'https://readdy.ai/api/search-image?query=top%20down%20view%20of%20a%20smartphone%20next%20to%20a%20notebook%20and%20spec%20comparison%20charts%20on%20a%20warm%20paper%20desk%2C%20minimal%20editorial%20photography%2C%20soft%20natural%20light%2C%20clean%20composition&width=900&height=600&seq=guide-buy-0001&orientation=landscape',
    imageAlt: '手机选购攻略配图',
    content: [
      { type: 'p', text: '每次新品发布前，总有一轮又一轮的参数曝光与价格预测轰炸视野。跑分、亮度、影像规格被反复放大，很多人反而不知道该如何取舍。' },
      { type: 'p', text: '我的建议很简单：先确定自己的核心使用场景，再反过来看参数。重度游戏就看散热与调度，拍照党就看影像算法与焦段覆盖，续航焦虑者就把电池与快充放第一位。' },
      { type: 'h3', text: '三条不踩坑的心法' },
      { type: 'p', text: '第一，别被单点峰值参数带节奏，综合体验更重要；第二，价格预测只是参考，正式发售价与优惠才是决定因素；第三，多看真实用户反馈而非只看参数表。把爆料当作「信息增量」，而不是「决策全部」。' },
    ],
  },
];

export const hotListIds = ['ling-zhi-xin-pian-zhongduan', 'zhedie-ping-xinji-sheji', 'yingxiang-qijian-jiaqian', 'shangshou-zhenji-xiaolong', 'shangxian-beiwoliu-shepian'];

export const siteFaqs = [
  {
    q: '每日新料的爆料内容来源可靠吗？',
    a: '我们会交叉核对供应链、研发圈与渠道等多方信源，只呈现「有时间点、可验证」的手机参数曝光、未发布产品图与厂商内部消息，并在页面对不确定的信息做明确标注，帮助读者理性判断。',
  },
  {
    q: '「参数曝光」与官方参数有什么区别？',
    a: '参数曝光来自爆料环节，代表工程阶段或量产前的规格方向，可能与最终零售版存在差异。我们坚持标注「疑似」「据传」，待厂商官宣后再做校对与更正。',
  },
  {
    q: '价格预测是怎么得出的？',
    a: '我们综合参考供应链成本、上一代定价、汇率与渠道预告等变量，给出配置梯度与定价区间的判断。价格预测是参考而非承诺，请以正式发售价为准。',
  },
  {
    q: '网上流传的未发布产品图可信吗？',
    a: '未发布产品图可能来自原型机或早期渲染，版权与真实性都需甄别。我们会注明图片来源与阶段，并区分「真机谍照」与「概念渲染」，避免误导读者。',
  },
  {
    q: '如何第一时间收到每日新料的最新爆料？',
    a: '你可以在首页底部的订阅栏留下邮箱，我们会在重要爆料与栏目更新时推送摘要；也可以持续访问本站栏目页面，最热的内容都会在首页与热榜优先展示。',
  },
  {
    q: '发现某条爆料有误，可以反馈吗？',
    a: '当然可以。我们欢迎读者通过「联系我们」表单指正。经核实后，我们会对相关内容进行更正并保留修改说明，确保内容的严谨与可信。',
  },
];